
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";

interface TransactionTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export function TransactionTypeSelect({ 
  value, 
  onChange,
  disabled = false,
  className 
}: TransactionTypeSelectProps) {
  return (
    <RadioGroup 
      value={value} 
      className={cn("flex gap-4", className)}
      onValueChange={onChange}
    >
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="entrada" id="entrada" disabled={disabled} />
        <Label htmlFor="entrada">Entrada</Label>
      </div>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="saida" id="saida" disabled={disabled} />
        <Label htmlFor="saida">Saída</Label>
      </div>
      <div className="flex items-center space-x-2">
        <RadioGroupItem value="despesas" id="despesas" disabled={disabled} />
        <Label htmlFor="despesas">Despesas Fixas</Label>
      </div>
    </RadioGroup>
  );
}
